import React, { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, Grid, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { isNumber } from '../../ModificationsUtils';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { validDecimal } from 'app/helpers/numberHelper';
import { usePromiseTracker } from 'react-promise-tracker';

export const LodgingPerDiemAdjustmentMod = () => {
  const { t } = useTranslation();
  const { control, getValues, setValue, clearErrors, setError } = useFormContext();
  const isChecked: any = useWatch({ name: 'dailyLodging' });
  const isModEdit = useSelector(selectIsEditMod);
  const [dailyChecked, setDailyChecked] = useState<boolean>(isChecked);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const lodgingAdjustment: any = useWatch({ name: 'lodgingPerDiemAdjustment' });
  const handleDailyToggle = () => {
    setDailyChecked(prev => !prev);
  };

  useEffect(() => {
    setDailyChecked(isChecked);
  }, [isChecked]);

  useEffect(() => {
    if (isNumber(getValues('lodgingPerDiemAdjustment'))) {
      clearErrors('lodgingPerDiemAdjustment');
    } else {
      setError('lodgingPerDiemAdjustment', { type: 'required' });
    }
  }, []);

  return (
    <>
      <Grid spacing={4} container height="370px">
        <Grid item xs={12}>
          <Controller
            name="lodgingPerDiemAdjustment"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value, ...rest } }) => (
              <Stack sx={{ width: '350px', height: '56px', verticalAlign: 'unset' }}>
                <TextField
                  value={lodgingAdjustment}
                  variant="filled"
                  label={`${t('placement.placementMods.lodgingPerDiemAdjustment')}`}
                  onChange={e => {
                    if (validDecimal(e.target.value, { numberLength: 3, decimalLength: 2 })) {
                      setValue('lodgingPerDiemAdjustment', e.target.value, { shouldDirty: true });
                      onChange(e.target.value);
                    }
                  }}
                  InputLabelProps={{
                    shrink: (isNumber(lodgingAdjustment) || lodgingAdjustment) ?? false,
                  }}
                  InputProps={{
                    readOnly: !isModEdit,
                    style: {
                      pointerEvents: !isModEdit ? 'none' : 'auto',
                    },
                    startAdornment: (
                      <>
                        {isNumber(getValues('lodgingPerDiemAdjustment')) && (
                          <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>
                        )}
                      </>
                    ),
                  }}
                  disabled={isSaveModApiCalling}
                  {...rest}
                />
                <Controller
                  name="dailyLodging"
                  control={control}
                  render={({ field: { onChange, value, ...rest } }) => (
                    <FormControlLabel
                      sx={{ marginTop: '6px' }}
                      control={
                        <Checkbox
                          id="dailyLodging"
                          checked={dailyChecked}
                          name="daily"
                          onKeyPress={event => {
                            if (event.key === 'Enter') {
                              handleDailyToggle();
                              onChange(event);
                            }
                          }}
                          disabled={!isModEdit || isSaveModApiCalling}
                          onChange={e => {
                            handleDailyToggle();
                            onChange(e.target.checked);
                            setDailyChecked(e.target.checked);
                          }}
                        />
                      }
                      label={<Typography color="#333333">{t('Daily')}</Typography>}
                    />
                  )}
                />
              </Stack>
            )}
          />
        </Grid>
      </Grid>
    </>
  );
};
